<template lang="pug">
  div(v-cloak)
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {}
  },
  created () {
    this.signIn()
      .then(() => {
        const referrer = sessionStorage.getItem('callback_referrer') || '/'
        sessionStorage.removeItem('callback_referrer')
        this.$router.push({ name: 'dispatch', query: { referrer: referrer } })
      })
      .catch(error => {
        console.dir(error)
        const tKey = `_account.${error.error}` || '_account.unknown_error'
        this.$toastr.error(this.$t(tKey))
        this.$router.push({
          name: 'account_sorry',
          query: { _n: new Date().getTime() }
        })
      })
  },
  methods: {
    ...mapActions(`common/${process.env.AUTH_STORATEGY}`, ['signIn'])
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Account/Callback/index.vue